import { render, staticRenderFns } from "./FragmentIframe.vue?vue&type=template&id=752a9031&"
import script from "./FragmentIframe.vue?vue&type=script&lang=ts&"
export * from "./FragmentIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports